var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoEdlenTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 391.1 153.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        font-family: AvenirLTStd-Roman, 'Avenir LT Std';\r\n        font-size: 36px;\r\n        letter-spacing: .2em;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill: #4e4e4e;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #a73c33;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.3,90.1h48.8v15.2H0V.3h64v15.2H15.3v29.6h47.6v15.3H15.3v29.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.7.3c34.4,0,51.7,26.3,51.7,52.6s-17.3,52.4-51.7,52.4h-37.7V.3h37.7ZM108.7,90.1c24.3,0,36.7-18.6,36.7-37.2s-12.3-37.4-36.6-37.4h-22.5v74.6h22.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183.4,90.1h49.4v15.2h-64.6V.3h15.2v89.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M257.6,90.1h48.8v15.2h-64.1V.3h64v15.2h-48.7v29.6h47.6v15.3h-47.6v29.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M313.2,105.3V0l11.7.2,51.2,74V.2h15v105.1h-12l-50.8-73.4v73.4h-15.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.3,122.4h-8.4v22.7h-3v-22.7H.4v-2.8h19.9v2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.3,142c-2,2.6-4.4,3.5-7.5,3.5-5.3,0-8.5-4-8.5-8.9s3.7-8.9,8.6-8.9,8,3.2,8,8.8v.9h-13.6c.2,2.9,2.4,5.4,5.5,5.4s4-.9,5.4-2.6l2.1,1.7ZM39.8,135.1c-.1-2.8-2-4.8-5.1-4.8s-5.1,1.9-5.5,4.8h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.5,140.6c1.1,1.4,2.3,2.3,4.3,2.3s3.7-.8,3.7-2.6-1.8-2.3-3.6-2.7c-3.2-.7-5.9-1.4-5.9-4.9s3.2-5,6.3-5,4.6.9,5.7,3.1l-2.3,1.5c-.7-1.2-1.9-2-3.6-2s-3.3.8-3.3,2.3,2,2,4.2,2.4c3,.6,5.5,1.7,5.5,5s-3.4,5.3-6.7,5.3-4.9-.8-6.6-3.1l2.2-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.6,130.6h-5v8.4c0,2.2,0,3.9,2.5,3.9s1.7-.2,2.5-.6v2.6c-.9.4-2.1.6-3.2.6-4,0-4.6-2.2-4.6-5.7v-9.2h-3.7v-2.4h3.7v-4.8h2.8v4.8h5v2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.5,119.6c1.2,0,2.1.9,2.1,2.1s-.9,2.1-2.1,2.1-2.1-.9-2.1-2.1.9-2.1,2.1-2.1ZM99.1,128.2h2.8v16.8h-2.8v-16.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.4,132.2c0-1.5-.1-2.9-.1-4h2.7c0,.9,0,1.8,0,2.8h0c.8-1.7,2.8-3.2,5.6-3.2,4.4,0,6.4,2.8,6.4,6.9v10.4h-2.8v-10.1c0-2.8-1.2-4.6-3.9-4.6s-5.2,2.6-5.2,6.5v8.2h-2.8v-12.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M160.1,144.3c0,6.1-3.3,9.4-9.2,9.4s-5.9-.9-8.3-3.2l2-2.3c1.8,1.9,3.7,2.9,6.3,2.9,5,0,6.4-3.2,6.4-6.8v-2.2h0c-1.3,2.2-3.7,3.1-5.9,3.1-5.3,0-9-3.7-9-8.6s3.6-8.9,9-8.9,4.8,1.1,5.9,3.3h0v-2.9h2.8v16.1ZM151.3,142.7c3.9,0,6-2.9,6-6.1s-2.4-6.2-6-6.2-5.9,2.7-5.9,6.3,2.7,6,5.9,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M190.1,132.3c0-7.7,5.6-13.4,13.3-13.4s13.3,5.7,13.3,13.4-5.6,13.4-13.3,13.4-13.3-5.7-13.3-13.4ZM213.5,132.3c0-5.9-4.1-10.6-10.1-10.6s-10.1,4.7-10.1,10.6,4.1,10.6,10.1,10.6,10.1-4.7,10.1-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229,132.2c0-1.5-.1-2.9-.1-4h2.7c0,.9,0,1.8,0,2.8h0c.8-1.7,2.8-3.2,5.6-3.2s.8,0,1.2.2l-.2,2.8c-.5-.1-1-.2-1.5-.2-3.4,0-4.9,2.4-4.9,6.3v8.2h-2.8v-12.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M262.9,142.1h0c-1,1.9-3.5,3.4-6.5,3.4-4.7,0-8.4-3.8-8.4-8.9s3.6-8.9,8.9-8.9,4.5,1.1,6,2.9h0v-12.8h2.8v27.2h-2.8v-3ZM256.9,130.4c-3.6,0-6,2.7-6,6.3s2.3,6.3,6,6.3,6-2.7,6-6.3-2.3-6.3-6-6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M293.8,142c-2,2.6-4.4,3.5-7.5,3.5-5.3,0-8.5-4-8.5-8.9s3.7-8.9,8.6-8.9,8,3.2,8,8.8v.9h-13.6c.2,2.9,2.4,5.4,5.5,5.4s4-.9,5.4-2.6l2.1,1.7ZM291.4,135.1c-.1-2.8-2-4.8-5.1-4.8s-5.1,1.9-5.5,4.8h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M306.7,132.2c0-1.5-.1-2.9-.1-4h2.7c0,.9,0,1.8,0,2.8h0c.8-1.7,2.8-3.2,5.6-3.2s.8,0,1.2.2l-.2,2.8c-.5-.1-1-.2-1.5-.2-3.4,0-4.9,2.4-4.9,6.3v8.2h-2.8v-12.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M328.9,119.6c1.2,0,2.1.9,2.1,2.1s-.9,2.1-2.1,2.1-2.1-.9-2.1-2.1.9-2.1,2.1-2.1ZM327.5,128.2h2.8v16.8h-2.8v-16.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M343.8,132.2c0-1.5-.1-2.9-.1-4h2.7c0,.9,0,1.8,0,2.8h0c.8-1.7,2.8-3.2,5.6-3.2,4.4,0,6.4,2.8,6.4,6.9v10.4h-2.8v-10.1c0-2.8-1.2-4.6-3.9-4.6s-5.2,2.6-5.2,6.5v8.2h-2.8v-12.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M388.5,144.3c0,6.1-3.3,9.4-9.2,9.4s-5.9-.9-8.3-3.2l2-2.3c1.8,1.9,3.7,2.9,6.3,2.9,5,0,6.4-3.2,6.4-6.8v-2.2h0c-1.3,2.2-3.7,3.1-5.9,3.1-5.3,0-9-3.7-9-8.6s3.6-8.9,9-8.9,4.8,1.1,5.9,3.3h0v-2.9h2.8v16.1ZM379.7,142.7c3.9,0,6-2.9,6-6.1s-2.4-6.2-6-6.2-5.9,2.7-5.9,6.3,2.7,6,5.9,6Z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(0 204.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Online Ordering"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEdlenTest);
export default __webpack_public_path__ + "static/media/logo-edlen-TEST.ae2255982eb7522604e83fbb31737097.svg";
export { ForwardRef as ReactComponent };